import type { ContentTopic } from "../../../@types/portalAluno";
import { asArray, asId, firstText } from "../coerce";

interface TopicApiItem {
  idTema?: unknown;
  nmTema?: unknown;
  dsTema?: unknown;
  titulo?: unknown;
}

export const mapApiTopics = (value: unknown): ContentTopic[] => {
  const seenIds = new Set<number>();

  return asArray<TopicApiItem>(value).reduce<ContentTopic[]>((topics, item) => {
    const id = asId(item.idTema);
    const name = firstText(item.nmTema, item.dsTema, item.titulo);

    if (!id || !name || seenIds.has(id)) return topics;

    seenIds.add(id);
    topics.push({ id, name });
    return topics;
  }, []);
};

export const mergeTopics = (groups: ContentTopic[][]): ContentTopic[] => {
  const byId = new Map<number, ContentTopic>();

  groups.forEach((group) =>
    group.forEach((topic) => {
      if (!byId.has(topic.id)) byId.set(topic.id, topic);
    })
  );

  return Array.from(byId.values()).sort((first, second) =>
    first.name.localeCompare(second.name, "pt-BR")
  );
};
